// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo_logoContainer__nv3zp","textLogo":"Logo_textLogo__AYcEL","newLogo":"Logo_newLogo__37fe2"};